var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrescriptionBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 3.16732H12.0003C12.3539 3.16732 12.6931 3.30779 12.9431 3.55784C13.1932 3.80789 13.3337 4.14703 13.3337 4.50065V13.834C13.3337 14.1876 13.1932 14.5267 12.9431 14.7768C12.6931 15.0268 12.3539 15.1673 12.0003 15.1673H4.00033C3.6467 15.1673 3.30756 15.0268 3.05752 14.7768C2.80747 14.5267 2.66699 14.1876 2.66699 13.834V4.50065C2.66699 4.14703 2.80747 3.80789 3.05752 3.55784C3.30756 3.30779 3.6467 3.16732 4.00033 3.16732H5.33366M6.00033 1.83398H10.0003C10.3685 1.83398 10.667 2.13246 10.667 2.50065V3.83398C10.667 4.20217 10.3685 4.50065 10.0003 4.50065H6.00033C5.63214 4.50065 5.33366 4.20217 5.33366 3.83398V2.50065C5.33366 2.13246 5.63214 1.83398 6.00033 1.83398Z",
    stroke: "#20B3D5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptionBlue);
export default __webpack_public_path__ + "static/media/prescriptionBlue.7ff7253211986810b245d46310c461bd.svg";
export { ForwardRef as ReactComponent };